import { IFormMetadata } from "../types";

/**
 * The forms `metadata` bag is opaque (`unknown`) on the wire contract. The
 * engine only understands the domain-agnostic `IFormMetadata` slice of it —
 * jurisdiction and attestation. These helpers narrow it defensively so the
 * renderer can read those without crashing when a form ships without (or with a
 * different) metadata shape. Domain layers may narrow further (e.g. the tax
 * layer's `ITaxFormMetadata`).
 */
export const asFormMetadata = (
  metadata: unknown
): IFormMetadata | undefined => {
  if (!metadata || typeof metadata !== "object") return undefined;
  return metadata as IFormMetadata;
};

export const getAttestationText = (metadata: unknown): string | undefined =>
  asFormMetadata(metadata)?.attestation?.text;

export const getJurisdictionCountry = (
  metadata: unknown,
  fallbackCountry: string
): string => asFormMetadata(metadata)?.jurisdiction?.country ?? fallbackCountry;
